export const DateComparator=(date1, date2) =>{
    // Convert dates to timestamps for comparison
    let timestamp1 = new Date(date1).getTime();
    let timestamp2 = new Date(date2).getTime();
    
    // Compare timestamps
    if (timestamp1 === timestamp2) {
        return 0;
    } else {
        return timestamp1 < timestamp2 ? -1 : 1;
    }
};